const TOKEN = 'token'
const ADMIN = 'admin'
const HEAD_TEACHER = 'headTeacher'
const CLUB_TEACHER = 'clubTeacher'
const TR = 'tr'

export { TOKEN, HEAD_TEACHER, CLUB_TEACHER, ADMIN, TR }



// WEBPACK FOOTER //
// ./src/constant/constant.js